/**
 * localStorage 命名空间封装（命名空间 `bluplanet-mobile:`）
 *
 * 统一读写入口，供状态层（RoleContext / EvidenceStore / draftStore）复用。
 * 所有方法对 JSON 序列化失败、配额溢出等异常做安全兜底，不向上抛出。
 */

/** 存储命名空间前缀 */
export const STORAGE_NS = 'bluplanet-mobile:';

/** 将相对 key 补全为带命名空间的完整 key */
export function withNamespace(key: string): string {
  return key.startsWith(STORAGE_NS) ? key : STORAGE_NS + key;
}

/** 读取 JSON，失败时回退到 fallback */
export function getJSON<T>(key: string, fallback: T): T {
  const fullKey = withNamespace(key);
  try {
    const raw = localStorage.getItem(fullKey);
    if (raw === null) return fallback;
    return JSON.parse(raw) as T;
  } catch (err) {
    console.warn(`[storage] 读取 ${fullKey} 失败，使用默认值`, err);
    return fallback;
  }
}

/** 写入 JSON */
export function setJSON<T>(key: string, value: T): void {
  const fullKey = withNamespace(key);
  try {
    localStorage.setItem(fullKey, JSON.stringify(value));
  } catch (err) {
    console.warn(`[storage] 写入 ${fullKey} 失败`, err);
  }
}

/** 删除指定 key */
export function removeKey(key: string): void {
  try {
    localStorage.removeItem(withNamespace(key));
  } catch (err) {
    console.warn(`[storage] 删除 ${withNamespace(key)} 失败`, err);
  }
}
